module.exports = __webpack_public_path__ + "img/logo-color.68afc480.jpg";